import { Color } from '../../../constants/color.constants';
import { StatusColor } from '../../../constants/status.constants';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'status-pill',
    styleUrls: ['./status-pill.component.scss'],
    template: `
        <div
            class="status-pill"
            [ngClass]="[color ? color : '', statusColor[status] ? statusColor[status] : '']"
            [ngStyle]="{ width: width || '8.5rem' }"
        >
            <span class="status-text">{{ displayValueMap[status] }}</span>
        </div>
    `
})
export class StatusPillComponent {
    @Input() public status: string;
    @Input() public displayValueMap: Record<any, any>;
    @Input() public color?: Color | StatusColor;
    @Input() public width?: string;
    public readonly statusColor = StatusColor;
}
